import { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import logo01 from "./assets/images/logo/logo.png";
import Router from "./routes/Router";
import CookieBanner from "./components/CookieBanner";

import "./App.css";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1500);
  }, []);

  return (
    <>
      {loading && (
        <div className="preload-container">
          <div className="middle">
            <img src={logo01} alt="DJ AstroChimp logo" className="loader-logo" />
          </div>
        </div>
      )}

      {!loading && (
        <>
          <Router />
          <CookieBanner />
        </>
      )}
    </>
  );
}

export default App;